import { render, staticRenderFns } from "./qwGeneralLeads.vue?vue&type=template&id=ff6dd0d8&scoped=true"
import script from "./qwGeneralLeads.vue?vue&type=script&lang=js"
export * from "./qwGeneralLeads.vue?vue&type=script&lang=js"
import style0 from "./qwGeneralLeads.vue?vue&type=style&index=0&id=ff6dd0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6dd0d8",
  null
  
)

export default component.exports